import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarAceptar } from '../../actions/tarifasEnvioPortes'
import i18n from '../../lang/idiomas'

const TarifasEnvioPortes = props => {
  const dispatch = useDispatch()

  const tarifa = useSelector(state => state.tarifa.tarifa)
  const aceptado = useSelector(state => state.tarifa.aceptado)
  const pedido = useSelector(state => state.pedidos.pedido)
  const locale = useSelector(state => state.precios.locale)
  const moneda = useSelector(state => state.precios.moneda)

  const [textoPortes, setTexoPortes] = useState(null)

  const total = pedido.lineas?.reduce(
    (total, lin) => Number.parseFloat(total) + Number.parseFloat(lin.importe_neto_lin || 0),
    0,
  )
  const pesoTotal = pedido.lineas.reduce(
    (pesoTotal, linea) =>
      pesoTotal + Number.parseFloat(linea.datos_articulo?.peso_neto * linea.cantidad_pedida || 0),
    0,
  )
  const nuevosPortes = pedido.cargos?.reduce((total, cargo) => {
    return total + parseFloat(cargo.importe_cargo / (1 + cargo.porcentaje_impto / 100))
  }, 0)

  useEffect(() => {
    cargarTextoPortes()
  }, [tarifa])

  const handleCheckboxChange = () => {
    dispatch(actualizarAceptar(!aceptado))
  }

  const cargarTextoPortes = () => {
    let v_texto = null
    switch (props?.tipo_tarifa) {
      case 'mixto':
        if (tarifa.importe_min_pagados && tarifa.peso_max_pagados) {
          v_texto =
            i18n.t('tarifa.tppasiis') +
            ' ' +
            new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: moneda,
            }).format(Number.parseFloat(tarifa.importe_min_pagados).toFixed(2)) +
            ' ' +
            i18n.t('tarifa.typesped') +
            Number.parseFloat(tarifa.peso_max_pagados).toFixed(2) +
            ' Kg'
        }
        break
      case 'texto_peso':
        if (tarifa.peso_max_pagados) {
          v_texto =
            i18n.t('tarifa.tppsipes') + ' ' + Number.parseFloat(tarifa.peso_max_pagados).toFixed(2)
        }

        break
      default:
        if (tarifa.importe_min_pagados) {
          v_texto =
            i18n.t('tarifa.tppasiis') +
            ' ' +
            new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: moneda,
            }).format(Number.parseFloat(tarifa.importe_min_pagados).toFixed(2))
        }
        break
    }
    setTexoPortes(v_texto)
  }

  return tarifa && props.mostrar_mensaje === 'S' && props.mostrar_porte !== 'S'
    ? tarifa
      ? (total < Number.parseFloat(tarifa.importe_min_pagados) ||
          pesoTotal > tarifa.peso_max_pagados) && (
          <div
            className='row tarifa-envio-portes'
            key={tarifa.forma_envio + '-' + tarifa.estado + '-' + tarifa.provincia}>
            {textoPortes}
            <div
              className='col-12'
              style={{ display: 'flex', justifyContent: 'center' }}>
              <input
                type='checkbox'
                id='tarifa-aceptada'
                name='tarifa-aceptada'
                checked={aceptado}
                required
                onClick={handleCheckboxChange}
              />
              <label
                for='tarifa-aceptada'
                style={{ fontWeight: '1000 px' }}>
                {!textoPortes ? i18n.t('tarifa.acpports') : i18n.t('tarifa.entend')}
              </label>
            </div>
          </div>
        )
      : pedido.cargos && (
          <div
            className='row tarifa-envio-portes'
            key={1}>
            {' '}
            {`${i18n.t('tarifa.newtaxes')} ` +
              new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: moneda,
              }).format(Number.parseFloat(nuevosPortes))}{' '}
            <div
              className='col-12'
              style={{ display: 'flex', justifyContent: 'center' }}>
              <input
                type='checkbox'
                id='tarifa-aceptada'
                name='tarifa-aceptada'
                required
                checked={aceptado}
                onClick={handleCheckboxChange}
              />{' '}
              <label
                for='tarifa-aceptada'
                style={{ fontWeight: '1000 px' }}>
                {' '}
                &nbsp; {i18n.t('tarifa.entend')}
              </label>
            </div>
          </div>
        )
    : props.mostrar_porte === 'S'
    ? pedido.cargos?.map((cargo, index) => (
        <div className='row'>
          <div className='col-7'></div>
          <div className='col-2 titulo'>{cargo.descripcion_cargo}</div>
          <div className='col-2 total'>
            {new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: moneda,
            }).format(
              Number.parseFloat(cargo.importe_cargo / (1 + cargo.porcentaje_impto / 100)).toFixed(
                2,
              ),
            )}
          </div>
          <div className='col-1'></div>
        </div>
      ))
    : nuevosPortes > 0 && (
        <div
          className='row tarifa-envio-portes'
          key={1}>
          {' '}
          {`${i18n.t('tarifa.newtaxes')} ` +
            new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: moneda,
            }).format(Number.parseFloat(nuevosPortes))}{' '}
          <div
            className='col-12'
            style={{ display: 'flex', justifyContent: 'center' }}>
            <input
              type='checkbox'
              id='tarifa-aceptada'
              name='tarifa-aceptada'
              required
              checked={aceptado}
              onClick={handleCheckboxChange}
            />{' '}
            <label
              for='tarifa-aceptada'
              style={{ fontWeight: '1000 px' }}>
              {' '}
              &nbsp; {i18n.t('tarifa.entend')}
            </label>
          </div>
        </div>
      )
}

export default TarifasEnvioPortes
